export const govActivityMock = {
  "data": {
      "monthlyActivity": [
          {
              "createdAt": "2023-10",
              "month": "10",
              "proposals": 8,
              "votes": 11350
          },
          {
              "createdAt": "2023-11",
              "month": "11",
              "proposals": 12,
              "votes": 16963
          },
          {
              "createdAt": "2023-12",
              "month": "12",
              "proposals": 3,
              "votes": 4694
          },
          {
              "createdAt": "2024-01",
              "month": "01",
              "proposals": 6,
              "votes": 6510
          },
          {
              "createdAt": "2024-02",
              "month": "02",
              "proposals": 9,
              "votes": 9819
          },
          {
              "createdAt": "2024-03",
              "month": "03",
              "proposals": 5,
              "votes": 7950
          },
          {
              "createdAt": "2024-04",
              "month": "04",
              "proposals": 6,
              "votes": 4538
          },
          {
              "createdAt": "2024-05",
              "month": "05",
              "proposals": 5,
              "votes": 7226
          },
          {
              "createdAt": "2024-06",
              "month": "06",
              "proposals": 6,
              "votes": 4890
          },
          {
              "createdAt": "2024-07",
              "month": "07",
              "proposals": 2,
              "votes": 1313
          },
          {
              "createdAt": "2024-08",
              "month": "08",
              "proposals": 5,
              "votes": 3287
          },
          {
              "createdAt": "2024-09",
              "month": "09",
              "proposals": 5,
              "votes": 2178
          },
          {
              "createdAt": "2024-10",
              "month": "10",
              "proposals": 1,
              "votes": 1223
          },
          {
              "createdAt": "2024-11",
              "month": "11",
              "proposals": 1,
              "votes": 331
          },
          {
              "createdAt": "2024-12",
              "month": "12",
              "proposals": 2,
              "votes": 2180
          },
          {
              "createdAt": "2025-01",
              "month": "01",
              "proposals": 6,
              "votes": 4351
          },
          {
              "createdAt": "2025-02",
              "month": "02",
              "proposals": 7,
              "votes": 4503
          },
          {
              "createdAt": "2025-03",
              "month": "03",
              "proposals": 1,
              "votes": 997
          },
          {
              "createdAt": "2025-04",
              "month": "04",
              "proposals": 5,
              "votes": 2429
          },
          {
              "createdAt": "2025-05",
              "month": "05",
              "proposals": 1,
              "votes": 189
          },
          {
              "createdAt": "2025-06",
              "month": "06",
              "proposals": 0,
              "votes": 38
          },
          {
              "createdAt": "2025-07",
              "month": "07",
              "proposals": 1,
              "votes": 782
          },
          {
              "createdAt": "2025-08",
              "month": "08",
              "proposals": 2,
              "votes": 1467
          },
          {
              "createdAt": "2025-09",
              "month": "09",
              "proposals": 1,
              "votes": 1311
          }
      ],
      "proposalActivity": {
          "proposalsCount": 305,
          "proposersCount": 72,
          "successfulProposalsCount": 128,
          "avgVotingPowerForWinningProposal": 5129913.357767053,
          "proposalParticipation": 0.07124339514357524,
          "voterParticipation": 15.63891472561398,
          "successfulProposalsPercentage": 41.967213114754095
      },
      "voteActivity": {
          "votesCount": 220780,
          "votersCount": 15805,
          "avgVotesPerProposal": 723,
          "votingPowerAgainst": 6838428.176176072,
          "votingPowerFor": 1163800265.1110973,
          "votingPowerAbstain": 83140030.9402382
      }
  }
};

export const yearByYearMock = {
  "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
  "voterInterestsType": "year_by_year",
  "aggregatedData": [
      {
          "year": 2021,
          "numberOfVotes": 34384
      },
      {
          "year": 2022,
          "numberOfVotes": 23748
      },
      {
          "year": 2023,
          "numberOfVotes": 93585
      },
      {
          "year": 2024,
          "numberOfVotes": 51445
      },
      {
          "year": 2025,
          "numberOfVotes": 9859
      }
  ],
  "createdAt": "2025-04-01T14:04:38.743Z"
};

export const govProposalsMock = {
  "data": [
      {
          "timePeriod": "Current",
          "total24Hours": 0,
          "total7Days": 0,
          "total30Days": 1,
          "total3Months": 4,
          "total6Months": 10,
          "total1Year": 28
      },
      {
          "timePeriod": "Previous",
          "total24Hours": 0,
          "total7Days": 1,
          "total30Days": 2,
          "total3Months": 6,
          "total6Months": 18,
          "total1Year": 72
      }
  ],
  "lastUpdate": "2025-09-30T04:08:49.150Z"
};

export const govSuccessfulProposals = {
  "data": [
      {
          "timePeriod": "Current",
          "total24Hours": 0,
          "total7Days": 0,
          "total30Days": 0,
          "total3Months": 2,
          "total6Months": 6,
          "total1Year": 11
      },
      {
          "timePeriod": "Previous",
          "total24Hours": 0,
          "total7Days": 0,
          "total30Days": 1,
          "total3Months": 4,
          "total6Months": 5,
          "total1Year": 27
      }
  ],
  "lastUpdate": "2025-09-30T04:08:49.237Z"
};

export const govVotesMock = {
  "data": [
      {
          "timePeriod": "Current",
          "total24Hours": 0,
          "total7Days": 588,
          "total30Days": 1311,
          "total3Months": 3560,
          "total6Months": 6326,
          "total1Year": 19828
      },
      {
          "timePeriod": "Previous",
          "total24Hours": 5,
          "total7Days": 723,
          "total30Days": 1467,
          "total3Months": 2766,
          "total6Months": 13502,
          "total1Year": 80946
      }
  ],
  "lastUpdate": "2025-09-30T04:11:46.876Z"
};

export const govVotersMock = {
  "data": [
      {
          "timePeriod": "Current",
          "total24Hours": 0,
          "total7Days": 586,
          "total30Days": 839,
          "total3Months": 1137,
          "total6Months": 1565,
          "total1Year": 2254
      },
      {
          "timePeriod": "Previous",
          "total24Hours": 5,
          "total7Days": 723,
          "total30Days": 825,
          "total3Months": 1268,
          "total6Months": 2056,
          "total1Year": 5796
      }
  ],
  "lastUpdate": "2025-09-30T04:14:21.902Z"
};

export const avVotesPerProposalMock = {
  "data": [
      {
          "timePeriod": "Current",
          "total24Hours": 0,
          "total7Days": 0,
          "total30Days": 735,
          "total3Months": 746,
          "total6Months": 562,
          "total1Year": 687
      },
      {
          "timePeriod": "Previous",
          "total24Hours": 0,
          "total7Days": 735,
          "total30Days": 734,
          "total3Months": 439,
          "total6Months": 756,
          "total1Year": 1116
      }
  ],
  "lastUpdate": "2025-09-30T04:14:48.602Z"
};